import { MultiSlider, Position } from "@blueprintjs/core"
import CustomPopover from "components/Atoms/CustomPopover"
import React from "react"
import classNames from "utils/classNames"

export const StockRangeLabel = ({ title, value, className }) => {
  return (
    <div className="flex justify-between items-center text-sm">
      <div className="flex items-center">
        <div
          className={`vt-muted ${className}`}
          style={{
            marginRight: 10,
            height: 10,
            width: 10,
          }}
        ></div>{" "}
        {title}
      </div>

      <div className="text-left">
        <span className="vt-dark">{value}</span>
      </div>
    </div>
  )
}

const StockRange = ({
  cs: csProp,
  hs: hsProp,
  os: osProp,
  bs: bsProp,
  rs: rsProp,
  className,
  style,
}) => {
  const num = csProp + hsProp + osProp + rsProp + bsProp
  // Find the divident
  const maxDivident = num / 10

  // Divide big numbers by the max dividents to get ratios between 0-10
  const cs = csProp / maxDivident
  const hs = hsProp / maxDivident
  const os = osProp / maxDivident
  const bs = bsProp / maxDivident
  const rs = rsProp / maxDivident
  return (
    <>
      {cs ? (
        <div
          style={style}
          className={classNames("vt-stock-range-container", className)}
        >
          <CustomPopover
            popoverClassName="vt-stock-range-popover"
            position={Position.BOTTOM_LEFT}
            minimal={true}
            interactionKind="hover"
            content={
              <div
                className="p-2"
                style={{
                  width: 200,
                }}
              >
                <StockRangeLabel
                  className="vt-bg-gray"
                  title="Ground Stock"
                  value={csProp}
                />
                <StockRangeLabel
                  className="vt-bg-success"
                  title="Display Stock"
                  value={osProp}
                />
                <StockRangeLabel
                  className="vt-bg-primary"
                  title="Hold Stock"
                  value={hsProp}
                />
                <StockRangeLabel
                  className="vt-bg-warning"
                  title="Booked Stock"
                  value={bsProp}
                />
                <StockRangeLabel
                  className="vt-bg-danger"
                  title="Rejected Stock"
                  value={rsProp}
                />
              </div>
            }
          >
            <MultiSlider className="vt-stocks-range" min={0} max={10}>
              <MultiSlider.Handle
                value={0}
                intentAfter="success"
                type="start"
              ></MultiSlider.Handle>
              <MultiSlider.Handle
                value={os}
                type="end"
                intentAfter="primary"
              ></MultiSlider.Handle>
              <MultiSlider.Handle
                value={os}
                type="start"
                intentAfter="primary"
              ></MultiSlider.Handle>
              <MultiSlider.Handle
                value={os + hs}
                type="end"
              ></MultiSlider.Handle>
              <MultiSlider.Handle
                value={os + hs}
                type="start"
                intentAfter="warning"
              ></MultiSlider.Handle>
              <MultiSlider.Handle
                value={os + hs + bs}
                type="start"
                intentAfter="warning"
              ></MultiSlider.Handle>
              <MultiSlider.Handle
                value={os + hs + bs}
                type="start"
                intentAfter="danger"
              ></MultiSlider.Handle>
              <MultiSlider.Handle
                value={os + hs + bs + rs}
                type="start"
              ></MultiSlider.Handle>
            </MultiSlider>
          </CustomPopover>

          <span className="text-center">
            {num} <span className="vt-highlight">Total</span>{" "}
          </span>
        </div>
      ) : (
        "No Ground Stock!"
      )}
    </>
  )
}
export default StockRange
